import React from 'react';
import { Trophy, Medal, Star } from 'lucide-react';
import Layout from '../components/layout/Layout';
import AchievementCard from '../components/common/AchievementCard';
import { useApp } from '../context/AppContext';

const AchievementsPage = () => {
  const { achievements, userProgress } = useApp();

  const earnedCount = achievements.filter(a => a.earned).length;
  const totalCount = achievements.length;

  return (
    <Layout title="Conquistas" showBack>
      <div className="px-4 py-6 space-y-6">
        {/* Header */}
        <div className="space-y-1">
          <h1 className="font-display text-2xl font-bold">Conquistas</h1>
          <p className="text-muted-foreground">
            Suas medalhas e progresso
          </p>
        </div>

        {/* Stats Summary */}
        <div className="card-elevated p-5">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center">
                <Trophy className="w-7 h-7 text-primary" />
              </div>
              <div>
                <p className="text-2xl font-bold">{earnedCount}/{totalCount}</p>
                <p className="text-sm text-muted-foreground">Conquistas desbloqueadas</p>
              </div>
            </div>
          </div>

          {/* Badges */}
          <div className="mt-4 pt-4 border-t border-border">
            <p className="text-sm text-muted-foreground mb-3">Seus badges</p>
            <div className="flex flex-wrap gap-2">
              {userProgress.badges.map(badge => (
                <div
                  key={badge.id}
                  className={`px-3 py-2 rounded-lg text-sm flex items-center gap-2 ${
                    badge.earned 
                      ? 'bg-primary/10 text-primary' 
                      : 'bg-muted text-muted-foreground'
                  }`}
                  title={badge.name}
                >
                  <span>{badge.icon}</span>
                  <span className="font-medium">{badge.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Achievements Grid */}
        <div className="space-y-4">
          <h2 className="font-display font-semibold text-lg flex items-center gap-2">
            <Medal className="w-5 h-5 text-accent" />
            Todas as Conquistas
          </h2>
          
          <div className="space-y-3">
            {achievements.map(achievement => (
              <AchievementCard 
                key={achievement.id} 
                achievement={achievement} 
              />
            ))}
          </div>
        </div>

        {/* Motivation */}
        <div className="p-4 rounded-xl bg-muted/50 text-center">
          <p className="text-sm text-muted-foreground">
            🎯 Continue estudando para desbloquear mais conquistas!
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default AchievementsPage;
